// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__+E0As","main":"footer_main__u24Pg"};